import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';

export default {
  ...queryBuilder.properties({
    remarks: { type: 'string', maxLength: 500 },
    natureOffer: { type: 'string', required: true },
  }),

  ...queryBuilder.if({ isNatureOfferAdvice: true }),
  then: {
    ...queryBuilder.properties({
      gardenAdvice: {
        ...queryBuilder.if({ hasOtherUpgrades: true }),
        then: {
          ...queryBuilder.properties({
            otherUpgrade: { type: 'string', required: true },
          }),
        },
        else: {
          ...queryBuilder.properties({
            otherUpgrade: { required: false },
          }),
        },
      },
    }),
  },
};
